<template>
<div :class="{'pp-tracklist':1, 'pp-tracklist--reverse': reversed }">
    <div v-for="item, index in items"
        :class="{'pp-tracklist__item':1, 'pp-tracklist__item--playing': currentTrack && item.id == currentTrack.id }"
        @dblclick="playTrack(item)">
        <div v-if="!maxRows || index < maxRows" class="pp-tracklist__item__container">
            <div class="pp-tracklist__item__playnow" @click="playTrack(item)">
                <i class="fa fa-fw fa-play"></i>
            </div>
            <div class="pp-tracklist__item__playing">
                <i class="fa fa-fw fa-volume-up"></i>
            </div>
            <div class="pp-tracklist__item__number">
                {{ item.position }}.
            </div>
            <div class="pp-tracklist__item__title">
                {{ item.title }}
            </div>
            <!--
                <div @click="playTrackNext(item)" class="pp-tracklist__item__playnext">
                    Play Next
                </div>
            -->
            <div @click="addToQueue(item)" class="pp-tracklist__item__playnext">
                Add to queue
            </div>
            <div class="pp-tracklist__item__duration">
                {{ item.duration | duration }}
            </div>
            <div class="pp-tracklist__item__quality">
                <span v-if="item.formats.indexOf('flac') > -1">FLAC</span>
            </div>
            <div v-if="allowRemove" @click="removeTrack(index)" class="pp-tracklist__item__remove">
                <i class="fa fa-fw fa-close"></i>
            </div>
        </div>
    </div>
    <loading-indicator v-if="paginating"></loading-indicator>
</div>
</template>


<script>
import EventBus from '../EventBus.js';
import TrackQueue from '../TrackQueue';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
    name: 'track-list',
    components: {
        LoadingIndicator
    },
    data() {
        return {
            currentTrack: null,
        };
    },
    mounted() {
        TrackQueue.on('changed', (e) => {
            this.reloadPlaying();
        });

        this.reloadPlaying();



        EventBus.on('navigation.scrolling', (e) => {
            if (this.canPaginate && !this.reachedEnd && !this.paginating && e.data.fromBottom < 300) {
                this.$emit('paginate');
            }
        })
    },
    methods: {
        reloadPlaying() {
            this.currentTrack = TrackQueue.current;
        },
        playTrack(track) {
            EventBus.emit('core.track.play', {
                track: track,
                context: this.items,
                mode: this.contextMode
            });
        },
        playTrackNext(track) {
            EventBus.emit('core.queue.addTrack', {
                track: track,
                next: true
            });
        },
        addToQueue(track) {
            EventBus.emit('core.queue.addTrack', {
                track: track,
                next: false
            });
        },
        removeTrack(index) {
            EventBus.emit('core.queue.removeTrack', {
                index: index,
                mode: this.contextMode
            });
        }
    },
    props: {
        items: Array,
        maxRows: Number,
        contextMode: String,
        reversed: Boolean,
        allowRemove: Boolean,
        canPaginate: Boolean,
        paginating: Boolean,
        reachedEnd: Boolean
    },

}
</script>



// WEBPACK FOOTER //
// TrackList.vue?ae771236